/* Kikaboni stack engine: the Build Your Stack recommendation rules.
 * One copy, used by the quiz (theme script, loaded before kb-quiz.js) and by
 * Kaia (imported by workers/kaia-wellness-advisor), so the two can't disagree.
 * ES5 + UMD because it must run as a plain theme <script> as well as a module. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.KbStackEngine = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var GOAL_CODES = ['MP', 'WM', 'SS', 'JB', 'GD', 'HH', 'FM', 'IM', 'PR'];
  // A component is removed for a diet only when its flag is explicitly false
  var DIET_KEYS = { vegetarian: 'vegetarian', vegan: 'vegan', gluten_free: 'gluten_free', dairy_free: 'dairy_free' };
  var HOLD_KEYS = { pregnancy: 'hold_pregnancy', blood_thinner: 'hold_blood_thinner', surgery: 'hold_surgery' };

  function stackByCode(stacks, code) {
    for (var i = 0; i < stacks.length; i++) if (stacks[i].code === code) return stacks[i];
    return null;
  }

  function evaluate(stacks, answers) {
    var a = answers || {};
    var stack = stackByCode(stacks || [], a.primary);
    if (!stack) return null;
    var diets = (a.diets || []).filter(function (d) { return d !== 'none'; });
    var safety = a.safety || [];
    var rx = safety.indexOf('rx') > -1;
    var providerNotice = safety.length > 0 && safety.indexOf('none') === -1;

    var items = [];
    var removed = [];
    stack.components.forEach(function (p) {
      var f = p.flags || {};
      var dropped = diets.some(function (d) { return DIET_KEYS[d] && f[DIET_KEYS[d]] === false; });
      if (dropped) { removed.push(p); return; }
      var held = safety.some(function (s) { return HOLD_KEYS[s] && f[HOLD_KEYS[s]] === true; });
      items.push(Object.assign({}, p, { held: held, caution: rx && f.caution_rx === true }));
    });

    var available = items.filter(function (p) { return !p.held; });
    // The bundle price only applies when nothing was removed or held
    var whole = items.length === stack.components.length && available.length === items.length &&
      stack.variant_id > 0 && stack.price > 0 && stack.available;

    return {
      stack: stack,
      items: items,
      available: available,
      starter: items.filter(function (p) { return p.core; }),
      full: items,
      removed: removed,
      whole: whole,
      defaultTier: a.experience === 'active' ? 'full' : 'starter',
      providerNotice: providerNotice,
      providerFirst: available.length < 2,
      secondary: a.secondary ? stackByCode(stacks, a.secondary) : null
    };
  }

  return { evaluate: evaluate, GOAL_CODES: GOAL_CODES, DIET_KEYS: DIET_KEYS, HOLD_KEYS: HOLD_KEYS };
});
